import cx from 'classnames';
import LinkIcon from '../../assets/icon/link.svg';
import HomeIcon from '../../assets/icon/home.svg';
import SearchIcon from '../../assets/icon/search.svg';
import HomeSearchIcon from '../../assets/icon/home-search.svg';
import StepBackIcon from '../../assets/icon/step-back.svg';
import Like from '../../assets/icon/like.svg';
import LikeActive from '../../assets/icon/like-active.svg';
import Collect from '../../assets/icon/collect.svg';
import CollectActive from '../../assets/icon/collect-active-icon.svg';
import ShareIcon from '../../assets/icon/share.svg';
import WxIcon from '../../assets/icon/wx.svg';
import TimelineIcon from '../../assets/icon/timeline.svg';
import QQIcon from '../../assets/icon/qq.svg';
import WeiboIcon from '../../assets/icon/weibo.svg';
import EmptyThreadIcon from '../../assets/icon/empty-thread.svg';
import CommentIcon from '../../assets/icon/comment.svg';
import ExtendIcon from '../../assets/icon/extend.svg';
import ArrowExtendIcon from '../../assets/icon/arrow-expand.svg';
import CloseIcon from '../../assets/icon/close.svg';
import TipsArrowIcon from '../../assets/icon/tips-arrow.svg';
import MoreArrowIcon from '../../assets/icon/more-arrow.svg';
import HomeMoreArrowIcon from '../../assets/icon/home-more-arrow.svg';
import FullScreenIcon from '../../assets/icon/full-screen.svg';
import CameraIcon from '../../assets/icon/camera.svg';
import CameraDisable from '../../assets/icon/camera-disable.svg';
import PhotoIcon from '../../assets/icon/photo.svg';
import PhotoDisable from '../../assets/icon/photo-disable.svg';
import EmojiIcon from '../../assets/icon/emoji.svg';
import KeykoardIcon from '../../assets/icon/keyboard.svg';
import WhiteClose from '../../assets/icon/white-close.svg';
import MClose from '../../assets/icon/m-close.svg';
import LoadingIcon from '../../assets/icon/loading.svg';
import LoadingWhiteIcon from '../../assets/icon/loading-white.svg';
import Skeleton from '../../assets/icon/skeleton.svg';
import ScancodeIcon from '../../assets/icon/scan-code.svg';
import CopyLinkIcon from '../../assets/icon/copy-link.svg';
import CommentErrorIcon from '../../assets/icon/comment-error.svg';
import EmptyComment from '../../assets/icon/empty-comment.svg';
import Reply from '../../assets/icon/reply.svg';
import ArrowLeft from '../../assets/icon/arrow-left.svg';
import ArrowRight from '../../assets/icon/arrow-right.svg';
import CommentSkeleton from '../../assets/icon/comment-skeleton.svg';
import NaveBackIcon from '../../assets/icon/nav.back.svg';
import NaveUserIcon from '../../assets/icon/nav.user.svg';
import AdminIcon from '../../assets/icon/admin.svg';
import VipIcon from '../../assets/icon/vip.svg';
import PageViewIcon from '../../assets/icon/page-view.svg';
import AllDevicesIcon from '../../assets/icon/all-devices.svg';
import NavBackHomeIcon from '../../assets/icon/nav-back-home.svg';
import NavDevicesBackIcon from '../../assets/icon/nav-devices-back.svg';
import HotIcon from '../../assets/icon/hot-colorful.svg';
import HotWhiteIcon from '../../assets/icon/hot-white.svg';
import StoreIcon from '../../assets/icon/store.svg';
import PinnedIcon from '../../assets/icon/pinned.svg';
import MenuIcon from '../../assets/icon/menu.svg';
import Praise from '../../assets/icon/praise.svg';
import PraiseActive from '../../assets/icon/praise-active.svg';
import FavoriteIcon from '../../assets/icon/favorite.svg';
import FavoriteActiveIcon from '../../assets/icon/favorite-active.svg';
import RankFirst from '../../assets/icon/rank-1.svg';
import RankSecond from '../../assets/icon/rank-2.svg';
import RankThird from '../../assets/icon/rank-3.svg';
import RankFour from '../../assets/icon/rank-4.svg';
import RankFive from '../../assets/icon/rank-5.svg';
import VerticalExtend from '../../assets/icon/vertical-extend.svg';
import ActivityTag from '../../assets/icon/activity-tag.svg';
import DeviceSeriesTag from '../../assets/icon/device-series-tag.svg';
import TestToolsIcon from '../../assets/icon/test-tools.svg';
import Styles from './index.module.scss';
import { ChannelTagDisplayTypeEnum } from '@/api/detail';
import LikeInFooter from '../../assets/icon/like-footer.svg';
import LikeInFooterActive from '../../assets/icon/like-footer-active.svg';
import CollectInFooter from '../../assets/icon/collect-footer.svg';
import CollectInFooterActive from '../../assets/icon/collect-active.svg';
import ReplyInFooter from '../../assets/icon/reply-footer.svg';
import ShareInFooter from '../../assets/icon/share-footer.svg';
import CameraFill from '../../assets/icon/camera-fill.svg';
import CheckedIcon from '../../assets/icon/checked.svg';
import StarIcon from '../../assets/icon/star.svg';
import ProfileSleleton from '../../assets/icon/profile-skeleton.svg';
import HeaderSearch from '../../assets/icon/header/search.svg';
import HeaderClose from '../../assets/icon/header/close.svg';
import Empty from '../../assets/icon/empty.svg'
import SearchArrowLeft from '../../assets/icon/search/search-arrow-left.svg'
import SearchCloseCircle from '../../assets/icon/search/search-close-circle.svg'
import SearchInputIcon from '../../assets/icon/search/search-input-icon.svg'
export interface ICommonIcon {
  className?: string;
  icon: string;
  onClick?: () => void;
}

const CommonIcon = ({
  className = '',
  icon,
  onClick = () => {},
}: ICommonIcon) => {
  const handleClick = () => {
    onClick();
  };

  const renderIcon = () => {
    switch (icon) {
      case 'test-tools':
        return <TestToolsIcon />;
      case 'pinned':
        return <PinnedIcon />;
      case 'menu':
        return <MenuIcon />;
      case 'store':
        return <StoreIcon />;
      case 'hot':
        return <HotIcon />;
      case 'hot-white':
        return <HotWhiteIcon />;
      case 'nav-devices-back':
        return <NavDevicesBackIcon />;
      case 'nav-back-home':
        return <NavBackHomeIcon />;
      case 'all-devices':
        return <AllDevicesIcon />;
      case 'link':
        return <LinkIcon />;
      case 'home':
        return <HomeIcon />;
      case 'search':
        return <SearchIcon />;
      case 'home-search':
        return <HomeSearchIcon />;
      case 'step-back':
        return <StepBackIcon />;
      case 'like':
        return <Like />;
      case 'like-active':
        return <LikeActive />;
      case 'collect':
        return <Collect />;
      case 'collect-active':
        return <CollectActive />;
      case 'share':
        return <ShareIcon />;
      case 'wx':
        return <WxIcon />;
      case 'timeline':
        return <TimelineIcon />;
      case 'qq':
        return <QQIcon />;
      case 'weibo':
        return <WeiboIcon />;
      case 'empty-thread':
        return <EmptyThreadIcon />;
      case 'comment':
        return <CommentIcon />;
      case 'extend':
        return <ExtendIcon />;
      case 'arrow-extend':
        return <ArrowExtendIcon />;
      case 'close':
        return <CloseIcon />;
      case 'tips-arrow':
        return <TipsArrowIcon />;
      case 'more-arrow':
        return <MoreArrowIcon />;
      case 'home-more-arrow':
        return <HomeMoreArrowIcon />;
      case 'full-screen':
        return <FullScreenIcon />;
      case 'camera':
        return <CameraIcon />;
      case 'camera-disable':
        return <CameraDisable />;
      case 'photo-disable':
        return <PhotoDisable />;
      case 'photo':
        return <PhotoIcon />;
      case 'emoji':
        return <EmojiIcon />;
      case 'keyboard':
        return <KeykoardIcon />;
      case 'white-close':
        return <WhiteClose />;
      case 'm-close':
        return <MClose />;
      case 'loading':
        return <LoadingIcon />;
      case 'loading-white':
        return <LoadingWhiteIcon />;
      case 'skeleton':
        return <Skeleton />;
      case 'scan-code':
        return <ScancodeIcon />;
      case 'copy-link':
        return <CopyLinkIcon />;
      case 'comment-error':
        return <CommentErrorIcon />;
      case 'empty-comment':
        return <EmptyComment />;
      case 'reply':
        return <Reply />;
      case 'arrow-left':
        return <ArrowLeft />;
      case 'arrow-right':
        return <ArrowRight />;
      case 'comment-skeleton':
        return <CommentSkeleton />;
      case 'nav-back':
        return <NaveBackIcon />;
      case 'nav-user':
        return <NaveUserIcon />;
      case 'admin-title':
        return <AdminIcon />;
      case 'vip-title':
        return <VipIcon />;
      case 'page-view':
        return <PageViewIcon />;
      case 'praise':
        return <Praise />;
      case 'praise-active':
        return <PraiseActive />;
      case 'favorite':
        return <FavoriteIcon />;
      case 'favorite-active':
        return <FavoriteActiveIcon />;
      case 'rank-1':
        return <RankFirst />;
      case 'rank-2':
        return <RankSecond />;
      case 'rank-3':
        return <RankThird />;
      case 'rank-4':
        return <RankFour />;
      case 'rank-5':
        return <RankFive />;
      case 'vertical-extend':
        return <VerticalExtend />;
      case ChannelTagDisplayTypeEnum.ACTIVITY:
        return <ActivityTag />;
      case ChannelTagDisplayTypeEnum.GROUP:
        return <DeviceSeriesTag />;
      case 'like-in-footer':
        return <LikeInFooter />;
      case 'like-in-footer-active':
        return <LikeInFooterActive />;
      case 'collect-in-footer':
        return <CollectInFooter />;
      case 'collect-in-footer-active':
        return <CollectInFooterActive />;
      case 'reply-in-footer':
        return <ReplyInFooter />;
      case 'share-in-footer':
        return <ShareInFooter />;
      case 'camera-fill':
        return <CameraFill />;
      case 'checked':
        return <CheckedIcon />;
      case 'star':
        return <StarIcon />;
      case 'profile-sleleton':
        return <ProfileSleleton />;
      case 'header-search':
        return <HeaderSearch />;
      case 'header-close':
        return <HeaderClose />;
      case 'empty-image':
        return <Empty />;
      // 搜索左箭头icon
      case 'search-arrow-left':
        return <SearchArrowLeft />;
      // 搜索关闭icon
      case 'search-close-circle':
        return <SearchCloseCircle />;
      // 搜索输入框图标icon
      case 'search-input-icon':
        return <SearchInputIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={cx(Styles.root, className)} onClick={handleClick}>
      { renderIcon() }
    </div>
  );
};

export default CommonIcon;
